module.exports = __webpack_public_path__ + "static/media/2017_8747.f03f0299.jpg";